import React, { useState } from 'react'
import Select from 'react-select'
import ThreeStateToggleButton from '../CommonComponents/ThreeStateToggleButton'
import { Loader } from 'rsuite';
import { useDispatch } from 'react-redux';
import { parseFullAddress } from '../../redux/actions/upload';
import { getParsedAddress } from '../../services/helper';

const CreateChildCheckTab = ({ checkInfo, columns, onChangeCheckInfo }) => {
    const dispatch = useDispatch()
    const [isParsingAddress, setIsParsingAddress] = useState(false)
    const paymentTermsOptions = [...Array(91)].map((_, i) => i)

    const handleChangeVendorAddress = (value) => {
        onChangeCheckInfo(columns[1].name, {
            label: value,
            value: value
        })
    }

    const parseAddress = async () => {
        if (checkInfo?.checkAddress1?.value) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(checkInfo?.checkAddress1?.value))
                const parsedResult = getParsedAddress(addressResult)
                onChangeCheckInfo('parseAddress', parsedResult)
                setIsParsingAddress(false)
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    return (
        <div className="check-tab">
            <div className="accept-list">
                <div className="accept-item">
                    <h4 className='fw-bold toggle-item-text text-black mb-0 flex-40'>Do they accept Check Payments?</h4>
                    <div className='flex justify-end'><ThreeStateToggleButton checked={checkInfo[columns[0].name].value} onChange={(checked) => onChangeCheckInfo(columns[0].name, { label: `${checked}`, value: checked })} /></div>
                </div>
                {checkInfo[columns[0].name].value && (
                    <>
                        <div className="accept-item">
                            <h4 className='fw-bold text-black mb-0 flex-40'>Check remittance address matches supplier address</h4>
                            <div className='flex justify-end'><ThreeStateToggleButton checked={checkInfo[columns[1].name].value} onChange={handleChangeVendorAddress} /></div>
                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">Address Line1:</h4>
                            <div className="search-input-parent d-flex gap-3">
                                <input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[2].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[2].name, { label: e.target.value, value: e.target.value })} />
                                {checkInfo?.checkAddress1?.value && !checkInfo[columns[1].name].value && (
                                    <div className="position-relative text-center">
                                        {isParsingAddress && <Loader size="sm" className="position-absolute start-0 end-0" />}
                                        <button
                                            type="button"
                                            className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 fs-6 bg-dark-blue rounded text-white`}
                                            onClick={parseAddress}
                                            disabled={checkInfo[columns[1].name].value}
                                        >
                                            Parse Address
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">Address Line2:</h4>
                            <div className="search-input-parent"><input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[3].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[3].name, { label: e.target.value, value: e.target.value })} /></div>

                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">City:</h4>
                            <div className="search-input-parent"><input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[4].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[4].name, { label: e.target.value, value: e.target.value })} /></div>
                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">State:</h4>
                            <div className="search-input-parent"><input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[5].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[5].name, { label: e.target.value, value: e.target.value })} /></div>
                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">Zip:</h4>
                            <div className="search-input-parent"><input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[6].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[6].name, { label: e.target.value, value: e.target.value })} /></div>
                        </div>
                        <div className="accept-item">
                            <h4 className="item-name text-black mb-0 flex-40">Country:</h4>
                            <div className="search-input-parent"><input className='search-input h4 mb-0' type="text" disabled={checkInfo[columns[1].name].value} value={checkInfo[columns[7].name].value || ''} onChange={(e) => onChangeCheckInfo(columns[7].name, { label: e.target.value, value: e.target.value })} /></div>

                        </div>

                        <div className="accept-item">
                            <h4 className='fw-bold text-black mb-0 flex-40'>Cash Payment Terms</h4>
                            <div className='flex justify-end'><ThreeStateToggleButton onChange={(checked) => onChangeCheckInfo(columns[8].name, { label: `${checked}`, value: checked })} checked={checkInfo[columns[8].name].value} /></div>
                        </div>

                        {
                            (checkInfo[columns[8].name].value) && (
                                <div className="accept-item payment-terms">
                                    <span className='label flex-40'>Payment Terms:</span>
                                    {
                                        checkInfo[columns[8].name].value ? (
                                            <Select
                                                className="cash-payment-terms-selector h4 mb-0"
                                                placeholder="Select..."
                                                options={
                                                    paymentTermsOptions.map((element) => (
                                                        {
                                                            label: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days'),
                                                            value: element === 0 ? 'Upon Receipt' : element + (element === 1 ? ' Day' : ' Days')
                                                        }
                                                    ))
                                                }
                                                value={checkInfo[columns[9].name]}
                                                onChange={(item) => onChangeCheckInfo(columns[9].name, item)}
                                            />
                                        ) : <div></div>
                                    }
                                </div>
                            )
                        }

                        <div className="accept-item">
                            <h4 className='fw-bold text-black mb-0 flex-40'>Do they offer cash Discount?</h4>
                            <div className='flex justify-end'><ThreeStateToggleButton onChange={(checked) => onChangeCheckInfo(columns[10].name, { label: `${checked}`, value: checked })} checked={checkInfo[columns[10].name].value} /></div>
                        </div>
                        {(checkInfo[columns[10].name].value) && (
                            <>
                                <div className="accept-item cash-discount-value">
                                    <h4 className='text-black fw-normal mb-0 flex-40'>Cash Discount:</h4>
                                    {checkInfo[columns[10].name].value ?
                                        <div className='flex processing-fee-dropdown-parent align-items-start align-center gap-2 flex-column'>
                                            <div className='d-flex ms-auto'>
                                                <div className='flex processing-fee-dropdown-child flex-grow-1'>
                                                    <Select
                                                        className="processing-fee-dropdown cash-discount-type-selector h4 mb-0"
                                                        placeholder="Select..."
                                                        options={
                                                            [
                                                                {
                                                                    label: '$',
                                                                    value: 'Dollar',
                                                                },
                                                                {
                                                                    label: '%',
                                                                    value: 'Percentage',
                                                                },
                                                            ]
                                                        }
                                                        value={checkInfo[columns[11].name]}
                                                        onChange={(item) => onChangeCheckInfo(columns[11].name, item, 'discounttype')}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="search-input cash-discount-value-input h4 mb-0"
                                                        onChange={(e) => onChangeCheckInfo(columns[12].name, { label: e.target.value, value: e.target.value }, checkInfo[columns[11].name]?.value === 'Dollar' ? 'currency' : 'percent')}
                                                        value={checkInfo[columns[12].name]?.value || ''}
                                                        placeholder={checkInfo[columns[11].name]?.value === 'Dollar' ? '1,234.00' : '12.50'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div></div>
                                    }
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
export default CreateChildCheckTab